import { createReducer, on } from '@ngrx/store';
import { IngredientWithProductsRecipesAttributes } from '../../models/ingredient';
import {
  loadIngredientsCostsSuccess,
  clearIngredientsCosts,
  updateIngredientCostSuccess,
} from './ingredients-costs.actions';

export const IngredientsCostsFeatureKey = 'ingredientsCosts';

export type IngredientsCostsState = {
  ingredients: IngredientWithProductsRecipesAttributes[],
}

const initialState: IngredientsCostsState = {
  ingredients: [],
};

export const ingredientsCostsReducer = createReducer(
  initialState,
  on(loadIngredientsCostsSuccess, (state, { ingredients }) => ({
    ...state,
    ingredients,
  })),
  on(updateIngredientCostSuccess, (state, { ingredientCost }) => ({
    ...state,
    ingredients: state.ingredients.map((ingredient) =>
      ingredient.id !== String(ingredientCost.ingredientId)
        ? ingredient
        : { ...ingredient },
    ),
  })),
  on(clearIngredientsCosts, () => initialState)
);
